import React, { useEffect, useState } from "react";
import { Modal, Input, Switch, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useResponsive } from "./EditColumnModal";


const AddColumnModal = ({
  open,
  onClose,
  onSave,
  reportRows,
  newColumnTitle,
  setNewColumnTitle,
  newIsPrivate,
  setNewIsPrivate,
  cellValues,
  setCellValues,
  cellPhotos,
  setCellPhotos,
  savingColumn
}) => {
  const { isMobile } = useResponsive();

  const handleFileChange = (bookingId, file) => {
    setCellPhotos(prev => ({ ...prev, [bookingId]: file }));
    return false; // Prevent auto upload
  };

  const handleTextChange = (bookingId, value) => {
    setCellValues(prev => ({ ...prev, [bookingId]: value }));
  };

  return (
    <Modal
      title={<span className={isMobile ? 'text-base' : ''}>Add New Section</span>}
      open={open}
      onCancel={onClose}
      onOk={onSave}
      confirmLoading={savingColumn}
      width={isMobile ? '95vw' : 700}
      okText={isMobile ? "Save" : "Save Section"}
      cancelText="Cancel"
      okButtonProps={{ 
        disabled: !newColumnTitle.trim(),
        style: { backgroundColor: '#298E9F' }
      }}
      centered={isMobile}
      bodyStyle={isMobile ? { maxHeight: '70vh', overflowY: 'auto' } : {}}
    >
      <div className={`space-y-${isMobile ? '4' : '6'}`}>
        {/* Column Title */}
        <div>
          <label className={`block font-semibold text-gray-700 mb-2 ${isMobile ? 'text-xs' : 'text-sm'}`}>
            Section Title *
          </label>
          <Input
            placeholder={isMobile ? "e.g., Diagnosis, Treatment" : "Enter column title (e.g., Diagnosis, Treatment, Notes)"}
            value={newColumnTitle}
            onChange={(e) => setNewColumnTitle(e.target.value)}
            size={isMobile ? 'middle' : 'large'}
            className="w-full"
          />
        </div>

        {/* Privacy Toggle */}
        <div className={`flex items-center justify-between ${isMobile ? 'p-3' : 'p-4'} bg-gray-50 rounded-lg`}>
          <div className="flex-1 pr-3">
            <div className={`font-semibold text-gray-700 ${isMobile ? 'text-sm' : ''}`}>
              Private Section
            </div>
            <div className={`text-gray-500 ${isMobile ? 'text-xs' : 'text-sm'}`}>
              {isMobile ? "Only visible to you" : "Only you can see this section's content"}
            </div>
          </div>
          <Switch
            checked={newIsPrivate}
            onChange={setNewIsPrivate}
            checkedChildren={isMobile ? "" : "Private"}
            unCheckedChildren={isMobile ? "" : "Public"}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AddColumnModal;